import { render, staticRenderFns } from "./FreightBrokerage.vue?vue&type=template&id=3dc96b2a&scoped=true"
import script from "./FreightBrokerage.vue?vue&type=script&lang=js"
export * from "./FreightBrokerage.vue?vue&type=script&lang=js"
import style0 from "./FreightBrokerage.vue?vue&type=style&index=0&id=3dc96b2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc96b2a",
  null
  
)

export default component.exports